module.exports = __webpack_public_path__ + "static/media/James-wong.26d224de.jpg";